import React, { useState } from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Es esto un tratamiento médico?',
  a: 'No, es un recurso espiritual que complementa tu salud.'
}, {
  q: '¿Me servirá si mi ansiedad es muy fuerte?',
  a: 'Sí, porque se enfoca en la respuesta física inmediata.'
}, {
  q: '¿Recibo algo por correo físico?',
  a: 'No, es un producto digital de acceso instantáneo para que lo uses hoy mismo.'
}, {
  q: '¿Es difícil de leer?',
  a: 'No, está diseñado con frases cortas y claras para mentes abrumadas.'
}];
export const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section variant="navy-light" data-id="element-14">
      <FadeIn data-id="element-15">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-16">
          Preguntas Frecuentes
        </h2>
      </FadeIn>

      <div className="max-w-2xl mx-auto space-y-4" data-id="element-17">
        {faqs.map((faq, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-18">
            <div className={`border rounded-xl overflow-hidden transition-colors duration-300 ${openIndex === idx ? 'border-gold/50 bg-navy' : 'border-white/10 bg-navy-light hover:border-white/20'}`} data-id="element-19">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-20">
                <span className={`font-medium text-lg ${openIndex === idx ? 'text-gold' : 'text-cream'}`} data-id="element-21">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 transition-transform duration-300 ${openIndex === idx ? 'rotate-180 text-gold' : 'text-cream-muted'}`} data-id="element-22" />
              </button>

              <AnimatePresence data-id="element-23">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-24">
                    <div className="px-6 pb-5 text-cream-muted" data-id="element-25">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};